module.exports = __webpack_public_path__ + "static/media/2-iphone-right.1c0a6d4c.png";